import { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { navLinks} from '../data/siteData'
import ThemeToggle from './ThemeToggle'
import './Navbar.css'

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
      if (open) {
    document.body.classList.add("menu-open");
  } else {
    document.body.classList.remove("menu-open");
  }

  return () => document.body.classList.remove("menu-open");
  
  }, [open])

  return (
    <header className={`nav-band ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="container nav-inner">

        <NavLink to="/" className="brand" onClick={() => setOpen(false)}>
          <span className="brand-mark" aria-hidden="true">
            <img
              src="/images/logo/logo.webp"
              alt=""
              width="500"
              height="500"
              onError={(e) => (e.currentTarget.style.display = 'none')}
            />
          </span>
          <span className="brand-text">
            <span className="brand-name">AS Elite Gatherings</span>
            <span className="brand-tagline">Every Gathering, Elevated</span>
          </span>
        </NavLink>

        <nav className="nav-links" aria-label="Primary">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              end={link.to === '/'}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="nav-actions">
          {/* <a href={business.phoneHref} className="nav-phone">
            {business.phone}
          </a> */}
          <NavLink to="/booking" className="btn btn-primary nav-cta">
            Book Now
          </NavLink>

          <span className="theme-toggle-desktop-slot">
            <ThemeToggle />
          </span>
          <button
            className={`nav-burger ${open ? 'open' : ''}`}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            aria-controls="mobile-side-menu"
            onClick={() => setOpen((o) => !o)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      <div
        className={`nav-backdrop ${open ? 'open' : ''}`}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      />

      <aside
        id="mobile-side-menu"
        className={`nav-drawer ${open ? 'open' : ''}`}
        aria-label="Mobile menu"
        aria-hidden={!open}
      >
        <div className="nav-drawer-head">
          <span className="nav-drawer-title">Menu</span>
          <button
            className="nav-drawer-close"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
          >
            ×
          </button>
        </div>

        <nav className="nav-drawer-links" aria-label="Mobile">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setOpen(false)}
              end={link.to === '/'}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <NavLink to="/booking" className="btn btn-primary nav-drawer-cta" onClick={() => setOpen(false)}>
          Book Now
        </NavLink>
{/* 
        <a href={business.phoneHref} className="nav-drawer-phone">
          {business.phone}
        </a> */}

        <div className="nav-drawer-theme">
          <span>Switch Theme</span>
          <ThemeToggle />
        </div>
      </aside>
    </header>
  )
}
